import { inject, Injectable } from '@angular/core';
import { HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';

import { of } from 'rxjs';
import { tap } from 'rxjs/operators';

import { RequestCache } from './request.cache.service';

/**
 * Intercepts every http request and cache the response
 */
@Injectable()
export class CacheInterceptor implements HttpInterceptor {
  cache = inject(RequestCache);

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    // Check if this is a no-cache request that should use short-term caching
    const isNoCacheRequest = req.headers.get('Cache-Control') === 'no-cache';

    // For GET requests, try to get from the cache first
    if (req.method === 'GET') {
      const cachedResponse = this.cache.get(req);
      if (cachedResponse) {
        return of(cachedResponse);
      }
    }

    // If not in cache or not a GET request, make the actual request
    return next.handle(req).pipe(
      tap((event) => {
        // Only cache successful GET responses
        if (event instanceof HttpResponse && req.method === 'GET' && event.status < 400) {
          // Put in cache with the noCache flag if appropriate
          this.cache.put(req.clone(), event.clone(), isNoCacheRequest);
        }
      }),
    );
  }
}
